import React from 'react';

const Header = ({ title }) => {

    return (
        <>
            <header>
                <h3 className="text-center font-weight-bold header-title">{title}</h3>
            </header>

        </>
    )
}

export default Header;